import { create } from 'zustand';

export interface ConciergePendingQuery {
  query: string;
  stacklineSku?: string;
}

interface ConciergeWidgetStoreState {
  isOpen: boolean;
  isMaximized: boolean;
  pendingQuery: ConciergePendingQuery | null;
  /** The product an explicit `askConcierge()` established, kept STABLE across the
   *  whole conversation — unlike `pendingQuery`, which clears after its one-shot
   *  auto-send. This is the product-context source on hosts that have no Shopify
   *  `bcProductMetaData` global (the Pages storefront), so every message carries
   *  `pdpStacklineSku` (the backend grounds the PDP answer + family lookup on it),
   *  not just the first. */
  activeStacklineSku: string | null;
  open: () => void;
  close: () => void;
  toggle: () => void;
  setMaximized: (maximized: boolean) => void;
  setPendingQuery: (pending: ConciergePendingQuery | null) => void;
  setActiveStacklineSku: (sku: string | null) => void;
}

export const useConciergeWidget = create<ConciergeWidgetStoreState>((set) => ({
  isOpen: false,
  isMaximized: false,
  pendingQuery: null,
  activeStacklineSku: null,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false, isMaximized: false }),
  toggle: () => set((state) => ({ isOpen: !state.isOpen })),
  setMaximized: (maximized: boolean) => set({ isMaximized: maximized }),
  setPendingQuery: (pending) => set({ pendingQuery: pending }),
  setActiveStacklineSku: (sku) => set({ activeStacklineSku: sku }),
}));
